module.exports = __webpack_public_path__ + "img/ic_topic_products-active.2c27e1f6.svg";